import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context';

export const SuperadminGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isSuperadmin } = useAuth();
  if (!isSuperadmin) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export default SuperadminGate;
